<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1">
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(fileCode)="data">
        <div style="color: #4caedc" @click="viewDetail(data.item.id)">{{ data.item.fileCode }}</div>
      </template>
      <template v-slot:cell(fileTitle)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.fileTitle)">{{ data.item.fileTitle }}</div>
      </template>
      <template v-slot:cell(remarks)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.remarks)">{{ data.item.remarks }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
    <div style="width: 100%; display: flex; justify-content: flex-end">
      <b-pagination
          v-model="tablePage.currentPage"
          :total-rows="tablePage.total"
          :per-page="tablePage.pageSize"
          aria-controls="my-table"
          small
          @change="tablePageChange"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import QueryInfoService from "@/api/system/queryInfoService";

export default {
  name: "ArmsRegArchiveFillingInfoDetail",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'fileCode', label: '文件编号', width: '120px'},
        {key: 'responsiblePerson', label: '责任者', width: '120px'},
        {key: 'fileCategory', label: '文件类别', width: '120px'},
        {key: 'fileTitle', label: '文件材料题名', width: '120px'},
        {key: 'fileDate', label: '日期', width: '120px'},
        {key: 'pageRange', label: '页次', width: '120px'},
        {key: 'fileStatusLabel', label: '文件状态', width: '120px'},
        {key: 'fileFormatLabel', label: '文件形式', width: '120px'},
        {key: 'catalogTypeLabel', label: '目录类型', width: '120px'},
        {key: 'sortOrder', label: '排序', width: '120px'},
        {key: 'remarks', label: '备注', width: '120px'},
      ],
      items: [],
      dictConfig: {
        arms_archive_file_status: 'fileStatus',
        arms_filing_file_format: 'fileFormat',
        arms_filing_file_catalog_type: 'catalogType'
      },
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        orders: []
      },
      id: '',
      archiveType: '',
      url: ''
    }
  },
  created() {
    this.id = this.$route.query.id
    this.archiveType = this.$route.query.archiveType
    this.url = this.archiveType === '1' ? '/arms/reg/armsRegArchiveFilingInfoFile/company/list' : '/arms/reg/armsRegArchiveFilingInfoFile/dept/list'
    this.init()
  },
  activated() {
    this.init()
  },
  methods: {
    init() {
      this.$flow.getDataList(this.url, {
        'current': this.tablePage.currentPage,
        'size': this.tablePage.pageSize,
        filingInfoId: this.id
      }).then(({data}) => {
        this.items = data.records
        if(this.items.length === 0) {
          this.$dialog.alert({
            message: '暂无数据',
            confirmButtonColor: '#409EFF'
          })
        }
        this.tablePage.total = data.total
        this.updateDictNames(this.items,this.dictConfig)
      })
    },
    async updateDictNames(dataList, dictTypeList) {
      const {data} = await new QueryInfoService().getDictMap();
      const promises = dataList.map(async (item) => {
        for (const [dictType, formField] of Object.entries(dictTypeList)) {
          if (data[dictType] && Array.isArray(data[dictType])) {
            const dictItem = data[dictType].find(d => d.value === item[formField]);
            if (dictItem) {
              this.$set(item, `${formField}Label`, dictItem.label);
            }
          }
        }
      });
    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    tablePageChange(value) {
      this.tablePage.currentPage = value
      this.init()
    },
    viewDetail(id) {
      this.$router.push({
        path: '/ArmsRegArchiveFillingInfoFile',
        query: {
          id: id,
          archiveType: this.archiveType,
          filingInfoId: this.id
        }
      })
    }
  }
}
</script>

<style scoped>
::v-deep .row-center td {
  vertical-align: middle;
}
</style>
